import { createSlice } from "@reduxjs/toolkit";
import { PaginationResponse, ResponseData } from "api/types/_public";
import { IToken } from "api/types/_token";
import { getTokens } from "./thunk";


export interface IState {
  tokens: ResponseData<IToken[]> & PaginationResponse | null,
  isTokenLoading: boolean,
  isTokenSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  tokens: null,
  isTokenLoading: false,
  isTokenSuccess: false,

  error: {},
};

const TokenSlice = createSlice({
  name: "Token",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Tokens
    builder.addCase(getTokens.pending, (state: IState, action: any) => {
      state.isTokenLoading = true
    });
    builder.addCase(getTokens.fulfilled, (state: IState, action: any) => {
      state.tokens = {
        list: typeof action.payload !== 'string' ? action.payload : [],
        pagination: {
          total: Number(action.payload?.length || 0),
          page: 1,
          limit: 100,
        }
      } as any;
      state.isTokenSuccess = true;
      state.isTokenLoading = false;
    });
    builder.addCase(getTokens.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isTokenSuccess = false;
      state.isTokenLoading = false;
    });
  },
});

export default TokenSlice.reducer;